import { get } from 'sortablejs'
import { createAPI } from '../../common'

export default {


    getRoot: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60gpmefst0sppu', 'get', config),
    getActionFolder: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0qfsnjttjpot0bdujpot0gpmefs', 'get', config),
    postActionFolder: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
            'post',
            config
        ),

}
